import styled from 'styled-components';
export const Button = styled.button `
  border: none;
  background: none;
  width: 35px;
  height: 35px;
  padding: 0;
  margin: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  position: relative;

  &[aria-expanded='true'] {
    opacity: 0.5;
  }
`;
export const OptionsContainer = styled.ul `
  width: 180px;
  display: flex;
  align-items: flex-start;
  padding: 0;
  flex-direction: column;
  overflow: hidden;
  margin: 0;
`;
//# sourceMappingURL=styles.js.map